import React, { useCallback, useState } from 'react';
import { View } from 'react-native';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Button, ButtonGroup } from 'app/src/elements/buttons';
import {
  Fields,
  defaultValues,
  prepareInput,
} from 'app/src/elements/hookForms';

import { FIELDS } from './new';
import { UPDATE_ACCOUNT } from './queries';

const EditAccount = ({ account, setShowModal, refetch, selects }) => {
  const [formStatus, setFormStatus] = useState();

  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS, resource: account })
  });

  const [updateAccount] = useMutation(UPDATE_ACCOUNT, {
    onCompleted: () => {
      refetch();
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setFormStatus('submitting');
    updateAccount({ variables: prepareInput(input, FIELDS) });
  });

  const fields = { ...FIELDS };
  fields.accountGroupId.select = selects.accountsWithCount.accountGroups;
  fields.parentId.select =
    selects.accountsWithCount.entries
    .map(entry => ({ value: entry.id, label: entry.fullName }));

  return (
    <View>
      <Fields
        fields={fields}
        control={control}
        errors={errors}
      />

      <ButtonGroup>
        <Button label="Update Account" onPress={handleSubmit(onSubmit)} />
      </ButtonGroup>
    </View>
  );
};

export default EditAccount;
